import React from "react";
import { useNavigate } from "react-router-dom";

const NaboraAdvertise = ({ data }) => {
  const navigate = useNavigate();

  const defaultData = {
    title: "Advertise Your Local Business",
    subtitle:
      "Reach nearby customers through Nabora's community-powered digital discovery ecosystem.",

    packages: [
      {
        icon: "📍",
        title: "Local Discovery Boost",
        desc: "Highlight your business to customers searching nearby.",
        type: "discovery",
      },
      {
        icon: "📺",
        title: "Digital Exhibition Promotion",
        desc: "Promote your products during Nabora monthly exhibitions.",
        type: "exhibition",
      },
      {
        icon: "🔥",
        title: "Featured Deal Placement",
        desc: "Showcase offers and coupons to increase customer visits.",
        type: "deal",
      },
    ],
  };

  const content = data || defaultData;

  const handleAdvertiseAction = (item) => {
    switch (item.type) {
      case "discovery":
        navigate("/finditlocal");
        break;

      case "exhibition":
        navigate("/nabora/exhibitions");
        break;

      case "deal":
        navigate("/nabora/deals");
        break;

      default:
        break;
    }
  };

  return (
    <div className="min-h-screen bg-slate-950 text-white">
      <div className="py-8 px-6 bg-gradient-to-br from-violet-950 via-purple-950 to-slate-950">
        <div className="max-w-5xl mx-auto text-center">
          <div className="uppercase tracking-[4px] text-yellow-300 text-sm mb-4">
            📣 NABORA ADVERTISE
          </div>

          <h1 className="text-2xl lg:text-4xl font-bold mb-4">
            {content.title}
          </h1>

          <p className="text-slate-300 text-base lg:text-xl max-w-3xl mx-auto">
            {content.subtitle}
          </p>

          <button
            onClick={() => navigate("/nabora/advertise/register")}
            className="mt-6 px-6 py-3 rounded-xl bg-gradient-to-r from-fuchsia-500 to-violet-600 font-bold hover:scale-105 transition-all shadow-xl shadow-purple-500/40"
          >
            🚀 Start Promotion
          </button>
        </div>
      </div>

      <div className="py-8 px-6">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-center text-xl lg:text-2xl font-bold text-cyan-200 mb-6">
            Grow Your Local Visibility
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            {content.packages.map((item, index) => (
              <div
                key={index}
                className="bg-slate-900/80 rounded-3xl p-6 border border-white/10 hover:border-purple-400/50 transition-all"
              >
                <div className="text-5xl mb-4">{item.icon}</div>

                <h3 className="text-gray-100 text-lg font-bold mb-3">{item.title}</h3>

                <p className="text-slate-300 text-sm lg:text-base">
                  {item.desc}
                </p>

                <button
                  onClick={() => handleAdvertiseAction(item)}
                  className="mt-5 w-full px-4 py-2 rounded-xl bg-gradient-to-r from-fuchsia-500 to-violet-600 font-semibold hover:scale-105 transition-all"
                >
                  Explore →
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="py-8 px-6 bg-gradient-to-br from-slate-900 to-violet-950">
        <div className="max-w-4xl mx-auto text-center">
          <div className="text-5xl mb-4">📺</div>

          <h2 className="text-xl lg:text-3xl font-bold mb-3 text-cyan-200">
            From Local Shops To Digital Brands
          </h2>

          <p className="text-slate-300 mb-6">
            Nabora helps businesses get discovered through digital exhibitions,
            local commerce and community-driven promotions.
          </p>

          <button
            onClick={() => navigate("/finditlocal")}
            className="px-6 py-3 rounded-xl border border-white/30 hover:bg-white/10 transition-all"
          >
            📍 Explore Local Discovery
          </button>
        </div>
      </div>
    </div>
  );
};

export default NaboraAdvertise;
